<template>
  <div class="select-box" ref="selectBox">
    <Select
      v-model="edu"
      filterable
      :remote-method="getEduList"
      @on-query-change="onQueryChange"
      @on-change="handleOnChange"
      @on-open-change="handleOpenChange"
      :loading="loading"
      clearable
      style="width: 200px"
    >
      <Option v-for="item in eduData" :value="item.orgId" :key="item.orgId">{{
        item.name
      }}</Option>
    </Select>
  </div>
</template>

<script>
import courseCenterApi from '@/request/courseCenter/index.js';
import { mapState } from 'vuex';
import { debounce } from '@/utils/tool.js'
export default {
  props: {
    eduId: {
      default: '0',
      type: String
    },

  },
  computed: {
    ...mapState({
      settlementSearch: state => state.orderCenter.settlementSearch,
      userInfo: state => state.userInfo
    }),
  },
  data() {
    return {
      eduData: [],
      num: 0,
      edu: '0',
      loading: false,
      pageInfo: {
        pageNum: 1,

        pageSize: 20
      },
      debounceFn: null //生成防抖函数

    }
  },
  watch: {
    eduId(newVal) {

      // if (newVal != this.edu && newVal !== '0') {
      //   this.edu = newVal

      // }


    }
  },
  created() {
    this.debounceFn = debounce(this.getEduListFun, 150);
    this.init()

  },
  methods: {
    init() {

      if (this.settlementSearch && this.settlementSearch.eduId) {
        this.edu = this.settlementSearch.eduId
        this.getEduList(this.settlementSearch.eduName)
      }

    }
  },
  onQueryChange(val) {

    if (!val) {
      this.getEduList()
    }
  },
  handleOpenChange(val) {
    if (val) {
      this.getEduList('')
    }
  },
  // 获取学校列表
  async getEduList(remoteVal = '') {

    // this.debounceFn(remoteVal)
    this.getEduListFun(remoteVal)
  },
  async getEduListFun(remoteVal) {
    const params = { ...this.pageInfo };

    if (!(['全部', 0, '0', this.eduId].includes(remoteVal))) {
      params.searchStr = remoteVal
    }
    if ([this.eduId].includes(remoteVal) && this.eduId != 0) {
      return null
    }
    // this.loading = true
    const res = await courseCenterApi.getEduListNew(params);

    // this.loading = false
    if (res.status === 200) {
      this.eduData = [{ orgId: '0', name: '全部' }, ...res.message.list];
    } else {
      this.$Message.error(res.message);
    }
    this.handleSelecteduHack()
  },
  // 处理  iview select 远程搜索 问题
  handleSelecteduHack() {
    this.$nextTick(() => {
      if (this.num < 2) {
        try {
          const dom = this.$refs.selectBox.getElementsByClassName('ivu-select-item-selected')[0]
          dom.click();
        } catch (err) { }
      }
      this.num++;
    });
  },
  async getVal() {
    return new Promise(async (resolve, reject) => {
      let key = await this.delaytime(500)
      let eduName = key > -1 ? this.eduData[key]['name'] : ''
      resolve({
        eduName,
        eduId: this.edu
      })
    })

  },
  async delaytime(time = 500) {
    let times = null,
      num = 0

    return new Promise((resolve, reject) => {
      times = setInterval(() => {
        let key = this.eduData.findIndex((item) => item.orgId == this.edu)
        if (key != -1) {
          clearInterval(times)
          resolve(key)
        }
        if (num == 15) {
          clearInterval(times)
          resolve(-1)
        }
        num = num + 1
      }, time)
    })
  },
  handleOnChange(val) {
    //this.$emit('input', v)
    let eduName = val ? this.eduData[this.eduData.findIndex((item) => item.orgId == val)]['name'] : ''
    this.$emit('on-edu-change', {
      eduName,
      eduId: val === undefined ? '0' : val
    })
  }


}
</script>

<style>
</style>